/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';
import { PLAN_BILL_CYCLE } from '@utils/constant';
import { useTranslation } from 'next-i18next';
import { cn } from '@lib/utils';

type ToggleProps = {
  billCycle: string | undefined;
  onChange: (e: any) => void;
  discount?: number;
  disabled?: boolean;
};

const Toggle: React.FC<ToggleProps> = ({
  billCycle,
  onChange,
  discount = 28,
  disabled = false,
}: ToggleProps) => {
  const { t } = useTranslation('planCard');

  const checked = billCycle === PLAN_BILL_CYCLE.MONTHLY;
  return (
    <section>
      <div className="flex justify-center">
        <label
          className={cn(
            'p-1 toggle-switch relative',
            checked ? 'checked' : '',
            disabled ? 'cursor-not-allowed' : 'cursor-pointer'
          )}
          htmlFor="toggle"
        >
          <div className="toggle-switch-labels">
            <input
              id="toggle"
              onChange={onChange}
              className="toggle-switch-checkbox"
              type="checkbox"
              checked={checked}
              disabled={disabled}
              aria-labelledby="toggleSwitchLabel"
            />
            <div className="flex w-full">
              <span className="flex-1 text-sm" id="toggleSwitchLabel">
                {t('planTypeYearly', { discount })}
              </span>
              <span className="flex-1 text-sm">{t('planTypeMonthly')}</span>
            </div>
          </div>
          <div
            className={cn(
              'toggle-switch-button',
              disabled ? 'bg-gray-300' : 'bg-secondary'
            )}
          />
        </label>
      </div>
    </section>
  );
};

export default Toggle;
